import { render, staticRenderFns } from "./CommentItem.vue?vue&type=template&id=28f88e01"
import script from "./CommentItem.vue?vue&type=script&lang=js"
export * from "./CommentItem.vue?vue&type=script&lang=js"
import style0 from "./CommentItem.vue?vue&type=style&index=0&id=28f88e01&prod&lang=scss"
import style1 from "./CommentItem.vue?vue&type=style&index=1&id=28f88e01&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports